import { render, staticRenderFns } from "./ProductsCreationUser.vue?vue&type=template&id=456490f7"
import script from "./ProductsCreationUser.vue?vue&type=script&lang=js"
export * from "./ProductsCreationUser.vue?vue&type=script&lang=js"
import style0 from "./ProductsCreationUser.vue?vue&type=style&index=0&id=456490f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports